import axios from 'axios';

/** true のあいだ、フロントはバックエンド（REST / Socket / 認証）を呼びません */
export const SKIP_API = false;

/** 本番APIのオリジン（REST / Socket.io 共通で使用） */
export const PROD_API_ORIGIN = 'https://japanese-moonlit-horizon-8959.fly.dev';

// Capacitorアプリ（capacitor:// または file://）では window.location.origin が
// "capacitor://localhost" になり、相対パスのAPI/Socket接続が失敗する。
// その場合のみ本番サーバーを明示的に指定する。
const isNativeApp =
  window.location.protocol === 'capacitor:' || window.location.protocol === 'file:';

/** REST と Socket.io が接続すべきオリジン。ネイティブアプリでは本番、Webでは同一オリジン。 */
export const API_ORIGIN = isNativeApp ? PROD_API_ORIGIN : window.location.origin;

if (isNativeApp) {
  axios.defaults.baseURL = PROD_API_ORIGIN;
}

// 通信タイムアウト。サーバーのコールドスタート（数秒）を考慮しつつ、
// 無応答時に「読み込み中…」のまま固まらないよう上限を設ける（2.1a 対策）。
axios.defaults.timeout = 20000; // 20s

// コールドスタートや一時的なネットワーク断に備え、
// タイムアウト／ネットワークエラー時に1回だけ自動リトライする。
axios.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error?.config;
    const isTimeout = error?.code === 'ECONNABORTED';
    const isNetwork = !error?.response; // レスポンスなし＝ネットワーク到達不可

    if (config && !config.__retried && (isTimeout || isNetwork)) {
      config.__retried = true;
      // 少し待ってからリトライ（サーバー起動待ち）
      await new Promise((r) => setTimeout(r, 1500));
      return axios(config);
    }
    return Promise.reject(error);
  }
);
